<ng-container *ngIf="dialog$ | async as dialog">
    <div class="modal-header modal-header--import flex-column" [ngSwitch]="step">
      <div class="modal-title">{{title}}</div>
      <div class="modal-subtitle mt-2" *ngSwitchCase="1">1. {{subtitle}} (Download <a [href]="file" class="template">template</a>) <a class="template" (click)="onToggleReadMore()">{{readmore ? 'hide more': 'read more'}}</a></div>
      <div class="modal-subtitle mt-2" *ngSwitchCase="2">2. Add images to imported auction items</div>
      <button type="button" class="cursor-pointer" class="close close--paybee position-absolute" data-dismiss="modal" aria-label="Close" (click)="close(dialog, false)">
        <span class="cursor-pointer" aria-hidden="true">×</span>
      </button>
      <div class="readmore mt-2" *ngIf="readmore">
        <div class="mb-2">Support File Format: Excel with header row</div>
        <table width="750" border="2" cellpadding="5" *ngIf="dialog.initialState.campaignType === 4">
            <thead>
                <tr>
                    <td><b>Column Name</b></td>
                    <td><b>Required</b></td>
                    <td><b>Description</b></td>
                    <td><b>Note</b></td>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Option name</td>
                    <td>required</td>
                    <td>Name of the Item</td>
                    <td>Full Name of Item (127 characters max)</td>
                </tr>
                <tr>
                    <td>Image Url</td>
                    <td>optional</td>
                    <td>Name of the image file name</td>
                    <td>Full Name of Image File</td>
                </tr>
                <tr>
                    <td>Additional Image URLs</td>
                    <td>optional</td>
                    <td>List of Image file names</td>
                    <td>If more than one, comma-separated</td>
                </tr>
                <tr>
                    <td>Total Item Count</td>
                    <td>required</td>
                    <td>Total Item Count</td>
                    <td>Total Item Count</td>
                </tr>
                <tr>
                    <td>Min Bid</td>
                    <td>required</td>
                    <td>Min Bid</td>
                    <td>Min Bid</td>
                </tr>
                <tr>
                    <td>Bid Increment</td>
                    <td>required</td>
                    <td>Bid Increment</td>
                    <td>Bid Increment</td>
                </tr>
                <tr>
                    <td>Value of  goods or services provided, if any!</td>
                    <td>optional</td>
                    <td>Value of  goods or services provided, if any!</td>
                    <td>By default 0</td>
                </tr>
                <ng-container *ngIf="dialog$ | async as dialog">
                    <ng-container *ngIf="dialog.initialState.auctionType == 0">
                        <tr>
                            <td>Enable But it Now</td>
                            <td>required</td>
                            <td>Enable But it Now</td>
                            <td>Enable But it Now (yes or no)</td>
                        </tr>
                        <tr>
                            <td>Buy it now Amount</td>
                            <td>optional</td>
                            <td>Min value 1, Max 400,000</td>
                            <td>Required if "Enable But it Now" is true</td>
                        </tr>
                    </ng-container>
                </ng-container>
                <tr>
                    <td>Collect sales tax for this item</td>
                    <td>required</td>
                    <td>Collect sales tax for this item</td>
                    <td>Collect sales tax for this item(yes or no)</td>
                </tr>
                <tr>
                    <td>Percentage Sales Tax</td>
                    <td>optional</td>
                    <td>The value should be from 0.01 to 100</td>
                    <td>Required if "Collect sales tax for this item" is true</td>
                </tr>
                <tr>
                    <td>Categories</td>
                    <td>optional</td>
                    <td>Categories</td>
                    <td>If multiple,  comma-separated.</td>
                </tr>
                <tr>
                    <td>Description</td>
                    <td>optional</td>
                    <td>Description</td>
                    <td>Description (2048 characters max)</td>
                </tr>
                <tr>
                    <td>Memo</td>
                    <td>optional</td>
                    <td>Memo</td>
                    <td>Memo (2048 characters max)</td>
                </tr>
                <tr>
                  <td>Featured </td>
                  <td>optional</td>
                  <td>Featured Item</td>
                  <td>Featured Item (can be true or false)</td>
                </tr>
                <tr>
                  <td>Donated By Name</td>
                  <td>optional</td>
                  <td>Donated By Name</td>
                  <td>Donated By Name (64 characters max)</td>
                </tr>
                <tr>
                  <td>Display Donated By</td>
                  <td>optional</td>
                  <td>Display Donated By</td>
                  <td>Display Donated By (can be true or false)</td>
                </tr>
                <tr>
                  <td>Item Code</td>
                  <td>optional</td>
                  <td>Item Code</td>
                  <td>Item Code (32 characters max)</td>
                </tr>
                <tr>
                  <td>Display To Donors</td>
                  <td>optional</td>
                  <td>Display To Donors</td>
                  <td>Display Item Code to donors (may be true or false)</td>
                </tr>
                <tr>
                  <td>Add Video</td>
                  <td>optional</td>
                  <td>Add Video</td>
                  <td>Add Video (can be true or false)</td>
                </tr>
                <tr>
                  <td>Video Provider</td>
                  <td>optional</td>
                  <td>Video Provider</td>
                  <td> Video Provider must be entered as a number: 1 for YouTube, 2 for Vimeo, 3 for Facebook, and 0 for Other (set to Other by default)</td>
                </tr>
                <tr>
                  <td>Video Provider Url</td>
                  <td>optional</td>
                  <td>Video Provider Url</td>
                  <td>The Video Provider URL must be entered as an embed link (128 characters max)</td>
                </tr>
                <tr>
                    <td>Any additional info required</td>
                    <td>optional</td>
                    <td>Any additional info required</td>
                    <td>User will enter additional info (yes or no)</td>
                </tr>
                <tr>
                    <td>Addtional info description</td>
                    <td>optional</td>
                    <td>Addtional info description</td>
                    <td>Required if "Any additional info required" is true</td>
                </tr>
                <tr>
                    <td>Instructions for additional info</td>
                    <td>optional</td>
                    <td>Instructions for additional info</td>
                    <td>Any instructions for additional info</td>
                </tr>
                <tr>
                    <td>Any additional info, to be selected by user</td>
                    <td>optional</td>
                    <td>Any additional info, to be selected by user</td>
                    <td>User will select additional info (yes or no)</td>
                </tr>
                <tr>
                    <td>Additional info select description</td>
                    <td>optional</td>
                    <td>Additional info select description</td>
                    <td>Required if "Any additional info, to be selected by user" is true</td>
                </tr>
                <tr>
                    <td>Options to be selected</td>
                    <td>optional</td>
                    <td>Options to be selected</td>
                    <td>Required if "Any additional info, to be selected by user" is true.<br> If multiple, comma-separated.</td>
                </tr>
            </tbody>
        </table>
        <ng-container *ngIf="dialog.initialState.campaignType === 5">
            <table width="750" border="2" cellpadding="5">
                <thead>
                    <tr>
                        <td><b>Column Name</b></td>
                        <td><b>Required</b></td>
                        <td><b>Description</b></td>
                        <td><b>Note</b></td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Item name</td>
                        <td>required</td>
                        <td>Name of the party</td>
                        <td>128 characters max</td>
                    </tr>
                    <tr>
                        <td>Images</td>
                        <td>optional</td>
                        <td>Name of one or more images by file or URL</td>
                        <td>File name or URL, Comma separated</td>
                    </tr>
                    <tr>
                        <td>Thumbnail</td>
                        <td>optional</td>
                        <td>Name of thumbnail image file or URL</td>
                        <td>File name or URL</td>
                    </tr>
                    <tr>
                        <td>Min Qty</td>
                        <td>required</td>
                        <td>Minimum quantity allowed per transaction</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Max Qty</td>
                        <td>required</td>
                        <td>Maximum quantity allowed per transaction</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Amount</td>
                        <td>required</td>
                        <td>Cost per spot of party</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Value of goods or services provided</td>
                        <td>optional</td>
                        <td>Value of goods or services provided, if any</td>
                        <td>Default is set to 0</td>
                    </tr>
                    <tr>
                        <td>Enforce item inventory for this option</td>
                        <td>required</td>
                        <td>Set a limit on the number of available spots per party</td>
                        <td>(yes/no), inventory count must be be set if yes</td>
                    </tr>
                    <tr>
                        <td>Inventory Count</td>
                        <td>optional</td>
                        <td>Number of available spots per party</td>
                        <td>(greater than 0), must be set only if previous field is set to yes</td>
                    </tr>
                    <tr>
                        <td>Hide item inventory for this option</td>
                        <td>optional</td>
                        <td>Hide the number of available spots per party from buyer</td>
                        <td>(yes/no), must be set only if previous field is set to yes</td>
                    </tr>
                    <tr>
                        <td>Send electronic tickets</td>
                        <td>required</td>
                        <td>Send electronic ticket with party details to buyer</td>
                        <td>(yes/no), set QR code flag if yes</td>
                    </tr>
                    <tr>
                        <td>Don't include QR codes in electronic ticket</td>
                        <td>optional</td>
                        <td>Choose to include QR codes in electronic tickets (useful if checking in buyers at party)</td>
                        <td>(yes/no), set if previous field is set</td>
                    </tr>
                    <tr>
                        <td>Display current ticket holders to buyers</td>
                        <td>required</td>
                        <td>Display list of all purchasers for this party</td>
                        <td>(yes/no)</td>
                    </tr>
                    <tr>
                        <td>Start Date/Time</td>
                        <td>optional</td>
                        <td>Start date and time when this party is visible and available for purchase</td>
                        <td>(Format: MM/DD/YY HH:MM AM/PM)</td>
                    </tr>
                    <tr>
                        <td>End Date/Time</td>
                        <td>optional</td>
                        <td>End date and time when this party is visible and available for purchase</td>
                        <td>(Format: MM/DD/YY HH:MM AM/PM)</td>
                    </tr>
                    <tr>
                        <td>Host Name</td>
                        <td>optional</td>
                        <td>Name of party host</td>
                        <td>128 characters max</td>
                    </tr>
                    <tr>
                        <td>Host Email</td>
                        <td>optional; required if name is set</td>
                        <td>Email of party host</td>
                        <td>128 characters max</td>
                    </tr>
                    <tr>
                        <td>Notify Host</td>
                        <td>optional; required if name is set</td>
                        <td>Send host email every time signs up for their party</td>
                        <td>(yes/no)</td>
                    </tr>
                    <tr>
                        <td>Display host information to buyers</td>
                        <td>optional; required if name is set</td>
                        <td>Show host's name to buyers</td>
                        <td>(yes/no)</td>
                    </tr>
                    <tr>
                        <td>Event detail link</td>
                        <td>optional; required if name is set</td>
                        <td>Link to party details</td>
                        <td>URL link; 128 characters max</td>
                    </tr>
                    <tr>
                        <td>Event Date/Time</td>
                        <td>optional; required if name is set</td>
                        <td>Start date and time of party</td>
                        <td>(Format: MM/DD/YY HH:MM AM/PM)</td>
                    </tr>
                    <tr>
                        <td>Duration in minutes</td>
                        <td>optional</td>
                        <td>Party duration in umber of minutes</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Venue Name</td>
                        <td>optional</td>
                        <td>Venue name (if any) of party</td>
                        <td>128 characters max</td>
                    </tr>
                    <tr>
                        <td>Address</td>
                        <td>optional</td>
                        <td>Address of the party venue</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Unit Num</td>
                        <td>optional</td>
                        <td>Party venue - Unit/Suite/Apt</td>
                        <td>128 characters max</td>
                    </tr>
                    <tr>
                        <td>Description</td>
                        <td>optional</td>
                        <td>Description of the party</td>
                        <td>2048 characters max</td>
                    </tr>
                    <tr>
                        <td>Summary</td>
                        <td>optional</td>
                        <td>Brief summary of the party</td>
                        <td>256 characters max</td>
                    </tr>
                </tbody>
            </table>
            <div class="mb-2">The following must be added as columns (after the Summary column) if you are collecting Additional Information for every party. The same 6 columns must be repeated for every question you add:</div>
            <table width="750" border="2" cellpadding="5">
                <thead>
                    <tr>
                        <td><b>Column Name</b></td>
                        <td><b>Required</b></td>
                        <td><b>Description</b></td>
                        <td><b>Note</b></td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Form Data Name 1</td>
                        <td>optional</td>
                        <td>Question</td>
                        <td>128 characters max</td>
                    </tr>
                    <tr>
                        <td>Form Data Type 1</td>
                        <td>optional; required if data name is set</td>
                        <td>Type of answer expected from buyer</td>
                        <td>
                            <div>Choose from 1-4</div>
                            <div>1 - Text</div>
                            <div>2 - Selection</div>
                            <div>3 - Street Address</div>
                            <div>4 - Phone Number</div>
                        </td>
                    </tr>
                    <tr>
                        <td>Form Data Values (if Type Selection) 1</td>
                        <td>optional; required if data type is 'selection'</td>
                        <td>If the buyer is expected to select one of the options provided, add the options here</td>
                        <td>Add answers, Comma separated</td>
                    </tr>
                    <tr>
                        <td>Form Data Required 1</td>
                        <td>optional; required if data name is set</td>
                        <td>If buyer must answer this question, set to yes</td>
                        <td>(yes/no)</td>
                    </tr>
                    <tr>
                        <td>Form Data Added Only by Admin (not shown to the buyers) 1</td>
                        <td>optional</td>
                        <td>If question must be answered by admins and not buyer, set to yes</td>
                        <td>(yes/no)</td>
                    </tr>
                    <tr>
                        <td>Form Data Description 1</td>
                        <td>optional</td>
                        <td>Description of questions, displayed to buyers</td>
                        <td>2048 characters max</td>
                    </tr>
                </tbody>
            </table>
        </ng-container>

      </div>
    </div>
    <div class="modal-body" *ngIf="!closeButton" [ngSwitch]="step">
        <app-import-xlsx
            *ngSwitchCase="1"
            [schema]="schema"
            [import]="import"
            [options]="options"
            (onChange)="onChangeOptions($event)"
        ></app-import-xlsx>
        <app-import-images
            *ngSwitchCase="2"
            [options]="options"
            (onChange)="onChangeImages($event)"
            (onChangeFiles)="onChangeFiles($event)"
            (onChangeMissed)="onCgangeMissed($event)"
            [disabled]="isUploading"
        ></app-import-images>
        <div class="file-list position-relative mt-4">
            <div class="file-list__content">
                <div class="file-card mb-2" *ngFor="let image of images.list; let i = index;">
                    <ng-container *ngIf="image.url">
                        <div class="row" *ngIf="image.error">
                            <div class="col-6 d-flex">
                                <div class="file-card__icon mr-2">
                                    <app-icon-file-small></app-icon-file-small>
                                </div>
                                <div class="file-card__name text-truncate">{{image.url}}</div>
                            </div>
                            <div class="col-6 d-flex justify-content-end">
                                <div class="file-card__error mr-2 text-truncate">{{image.error}}</div>
                            </div>
                            <div class="col-6 d-flex justify-content-end" *ngIf="image.uploaded">
                                <app-icon-success class="mr-0"></app-icon-success>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-body" *ngIf="closeButton">
        <div *ngIf="closeButton" class="d-flex flex-column align-items-center my-5">
            <div>Successfully loaded {{options.length}} items.</div>
            <div>New items will appear at the bottom.</div>
        </div>
    </div>
    <div class="modal-footer modal-footer--import">
        <div class="d-flex justify-content-between w-100">
            <div class="col-8 d-flex align-items-center">
                <ng-container [ngSwitch]="step">
                    <ng-container *ngSwitchCase="1">
                        <div *ngIf="import.value" class="modal__found">{{options.length}} items, {{imageUrls}} image URLs, {{localImages}} local images found</div>
                    </ng-container>
                    <ng-container *ngSwitchCase="2">
                        <ng-container *ngIf="images.status === 0">
                            <div *ngIf="images.length > 0" class="modal__found">{{imageUrls}} image URLs, {{choosenImages.length}} local images found</div>
                        </ng-container>
                        <div *ngIf="images.status === 1" class="modal__found">
                            <span>Uploading... {{images.remaining}} images remaining...</span>
                            <img src="/img/gif/spinner-1s-200px.gif" height="38" width="38" /></div>
                        <div *ngIf="images.status === 2" class="modal__found">{{images.uploaded}} images successfully uploaded</div>
                    </ng-container>
                </ng-container>
            </div>
            <div class="col-4">
                <div class="row">
                    <div class="col-6">
                        <button
                            *ngIf="isNotFirstStep && !closeButton"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="goToPrevStep()"
                            [disabled]="prevStepDisabled"
                        >Previous</button>
                    </div>
                    <div class="col-6">
                        <button
                            *ngIf="nextStepDisplay"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="goToNextStep()"
                            [disabled]="nextStepDisabled"
                        >Next</button>
                        <button
                            *ngIf="upload && (images.length > 0 || hasLinks)"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="onStart(dialog)"
                            [disabled]="nextStepDisabled"
                        >Upload</button>
                        <button
                            *ngIf="upload && images.length < 1 && !hasLinks"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="onSkip(dialog)"
                        >Skip</button>
                        <button
                            *ngIf="confirm"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="onConfirm(dialog)"
                        >Confirm</button>
                        <button
                            *ngIf="closeButton"
                            type="button"
                            class="btn btn--paybee btn--black btn--md text-center w-100"
                            (click)="onClose(dialog)"
                        >Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </ng-container>
